import React from 'react';
import { observer } from 'mobx-react-lite';
import AddEmployeesPageStore, { AddEmployeesPageStoreContext } from 'store/pages/enrollment/add-employees/pageStore';
import { PageContent } from 'components/enrollment/add-employees';
import ProposalStatusLayout from 'components/common/proposal/ProposalStatusLayout';
import { useEnrollmentDomainParams } from 'global/hooks/useEnrollmentDomainParams';
import { PageWrapperStyled } from '../../../../globalStyles';

/* TESTING_POLICY: CYPRESS_ONLY */

const AddEmployeesPage: React.FC = observer(() => {
  const { periodId, groupId } = useEnrollmentDomainParams();

  return (
    <AddEmployeesPageStoreContext.Provider value={new AddEmployeesPageStore({ groupId, periodId })}>
      <ProposalStatusLayout>
        <PageWrapperStyled>
          <PageContent />
        </PageWrapperStyled>
      </ProposalStatusLayout>
    </AddEmployeesPageStoreContext.Provider>
  );
});

export default AddEmployeesPage;
